import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { FulfillmentOrderRoot } from '@repo/sdk'

import { BuyerLink } from '../../components/BuyerLink'

interface BuyerInfoCardProps {
  order: FulfillmentOrderRoot
}

export function BuyerInfoCard({ order }: BuyerInfoCardProps) {
  const { t } = useTranslation()

  return (
    <Card title={t('pages.orders.sections.buyerInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.orders.fields.buyerNickname')}>
          <BuyerLink buyer={order.buyer} showAvatar />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
